{
  "name": "bdo-webpanel",
  "version": "26.3.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prebuild": "npm --no-git-tag-version version patch",
    "build": "ng build && npm run sentry:sourcemaps",
    "build:stats": "ng build --stats-json",
    "analyze": "source-map-explorer dist/bdo-webpanel/browser/*.js --html analyze-report.html && echo 'Report generated: analyze-report.html'",
    "test": "ng test",
    "lint": "ng lint",
    "test:dependency": "owasp-dependency-check --project \"bdo-mobile-webpanel\" --scan \"package-lock.json\" --exclude \"dependency-check-bin\" --out \"owasp\" --format XML",
    "test:dependency:json": "owasp-dependency-check --project \"bdo-mobile-webpanel\" --scan \"package-lock.json\" --exclude \"dependency-check-bin\" --out \"owasp\" --format JSON",
    "test:dependency:html": "owasp-dependency-check --project \"bdo-mobile-webpanel\" --scan \"package-lock.json\" --exclude \"dependency-check-bin\" --out \"owasp\" --format HTML",
    "build-light-theme": "sass src/assets/themes/tailwind/tailwind-light/theme.scss:src/assets/themes/material/light/theme.css",
    "build-dark-theme": "sass src/assets/themes/tailwind/tailwind-dark/theme.scss:src/assets/themes/material/dark/theme.css",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org mobiletract --project panel-bdo-mobile ./dist/bdo-webpanel && sentry-cli sourcemaps upload --org mobiletract --project panel-bdo-mobile ./dist/bdo-webpanel"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.4",
    "@angular/cdk": "^20.2.8",
    "@angular/common": "^20.3.4",
    "@angular/compiler": "^20.3.4",
    "@angular/core": "^20.3.4",
    "@angular/forms": "^20.3.4",
    "@angular/platform-browser": "^20.3.4",
    "@angular/platform-browser-dynamic": "^20.3.4",
    "@angular/router": "^20.3.4",
    "@angular/service-worker": "^20.3.4",
    "@ekowitryna/ui": "20.1.3-dev83",
    "@fontsource-variable/mulish": "^5.2.8",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@mobiletract/account-service-angular-client": "26.3.0-dev.b34",
    "@mobiletract/auth-service-angular-client": "26.3.0-dev.b34",
    "@mobiletract/packaging-management-service-angular-client": "26.3.0-dev.b34",
    "@mobiletract/reporting-service-angular-client": "^26.3.0-dev.b41",
    "@mobiletract/wasterecord-service-angular-client": "26.3.0-dev.b35",
    "@ngrx/component-store": "^20.0.1",
    "@ngrx/effects": "^20.0.1",
    "@ngrx/store": "^20.0.1",
    "@ngrx/store-devtools": "^20.0.1",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeng/themes": "^20.2.0",
    "@primeuix/utils": "^0.6.1",
    "@sentry/angular-ivy": "^7.120.4",
    "@sentry/cli": "^2.56.1",
    "angular-google-tag-manager": "^1.11.0",
    "chart.js": "^4.5.0",
    "date-fns": "^4.1.0",
    "date-fns-tz": "^3.2.0",
    "flag-icons": "^7.5.0",
    "jasmine-marbles": "^0.9.2",
    "json-formatter-js": "^2.5.23",
    "keycloak-angular": "^20.0.0",
    "keycloak-js": "^26.2.1",
    "ngx-gravatar": "^13.0.0",
    "ngx-pl-validators": "^1.0.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.2.0",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "validate-polish": "^2.1.40",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^20.3.5",
    "@angular-devkit/core": "^20.3.5",
    "@angular-devkit/schematics": "^20.3.5",
    "@angular-eslint/builder": "^20.3.0",
    "@angular-eslint/eslint-plugin": "^20.3.0",
    "@angular-eslint/eslint-plugin-template": "^20.3.0",
    "@angular-eslint/template-parser": "^20.3.0",
    "@angular/cli": "^20.3.5",
    "@angular/compiler-cli": "^20.3.4",
    "@ngrx/eslint-plugin": "^20.0.1",
    "@schematics/angular": "^20.3.5",
    "@tailwindcss/postcss": "^4.1.14",
    "@types/jasmine": "^5.1.9",
    "@types/mocha": "^10.0.10",
    "@types/node": "^24.7.2",
    "@typescript-eslint/eslint-plugin-tslint": "^7.0.2",
    "angular-eslint": "^20.3.0",
    "autoprefixer": "^10.4.21",
    "eslint": "^9.37.0",
    "jasmine-core": "~5.12.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "owasp-dependency-check": "^1.0.0",
    "postcss": "^8.5.6",
    "source-map-explorer": "^2.5.3",
    "tailwindcss": "^4.1.14",
    "ts-node": "~10.9.2",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.46.0",
    "webpack-bundle-analyzer": "^4.10.2"
  },
  "optionalDependencies": {
    "@rollup/rollup-linux-x64-gnu": "^4.52.4"
  }
}
